import React from 'react';
import { useRoughNotation, type RoughOptions } from '../hooks/useRoughNotation';

/* Wraps a phrase and hand-marks it when it scrolls into view. The outer span is
   positioned so rough-notation's absolutely placed SVG shares its origin, and
   inline-block so the marked phrase never breaks across two lines.
   One mark per section is the house rule. */
export function Rough({
    children,
    className = '',
    ...options
}: { children: React.ReactNode; className?: string } & RoughOptions) {
    const ref = React.useRef<HTMLSpanElement>(null);
    useRoughNotation(ref, options);
    return (
        <span className={['ds-rough', className].filter(Boolean).join(' ')}>
            <span ref={ref} className="ds-rough__word">
                {children}
            </span>
        </span>
    );
}
